/* eslint-disable react/no-array-index-key */
import React, { ComponentPropsWithRef, FC } from 'react';
import classnames from 'classnames';

import styles from './PlcAccordionList.module.scss';

interface Props {
  source?: string;
}

const PlcAccordionList: FC<Props & ComponentPropsWithRef<'div'>> = ({ source, className, ...rest }) => {
  const rootClass = classnames(styles.plcAccordionList, className);
  return <div className={rootClass} {...rest} />;
};

export { PlcAccordionList };
